import React from 'react';
const withError = (WrappedComponent, FallbackComponent, errorHandler) => {
    return class extends React.Component {
        constructor() {
            super(...arguments);
            this.state = { error: undefined };
            this.renderFallback = () => FallbackComponent ? React.createElement(FallbackComponent, { error: this.state.error }) : null;
        }
        static getDerivedStateFromError(error) {
            return { error };
        }
        componentDidCatch(error, info) {
            if (errorHandler) {
                errorHandler(error, info);
            }
            else {
                console.log(error, info);
            }
        }
        render() {
            return this.state.error ? this.renderFallback() : React.createElement(WrappedComponent, { ...this.props });
        }
    };
};
export default withError;
//# sourceMappingURL=with-error.js.map